/**
 * ApexCharts sizes bars as a share of each category slot, so a fixed percentage
 * produces absurdly thick bars when there are only one or two categories.
 * These helpers shrink the share as the category count drops, which keeps bar
 * thickness roughly constant no matter how many rows the report returns.
 */

export const columnWidthFor = (count) => {
  if (count <= 1) return "12%";
  if (count <= 2) return "20%";
  if (count <= 4) return "32%";
  if (count <= 8) return "45%";
  return "60%";
};

/** Same idea for horizontal bars, where the knob is `barHeight`. */
export const barHeightFor = (count) => {
  if (count <= 1) return "22%";
  if (count <= 2) return "34%";
  if (count <= 4) return "48%";
  return "62%";
};

/**
 * Data labels sitting on top of a column need enough offset to clear the bar,
 * plus headroom on the y-axis so the topmost label isn't clipped by the frame.
 */
export const TOP_DATA_LABEL_OFFSET = -26;

export const topDataLabelStyle = (color) => ({
  enabled: true,
  offsetY: TOP_DATA_LABEL_OFFSET,
  style: { colors: [color], fontSize: "11px", fontWeight: 600 },
  background: { enabled: false },
});
